import { createAction, props } from '@ngrx/store';

import {
	BeneficiaryGroupUser,
	GroupUser,
	OrgGroups,
	Permission,
} from '../models/groups.model';

import {
	FETCH_GROUPS_FAILURE,
	FETCH_GROUPS_START,
	FETCH_GROUPS_SUCCESS,
	FETCH_USERS_FAILURE,
	FETCH_USERS_START,
	FETCH_USERS_SUCCESS,
	UPDATE_USERS_START,
	UPDATE_USERS_SUCCESS,
	UPDATE_USERS_FAILURE,
	UPDATE_PERMISSIONS_START,
	UPDATE_PERMISSIONS_SUCCESS,
	UPDATE_PERMISSIONS_FAILURE,
	FETCH_ALL_USERS_ORG_START,
	FETCH_ALL_USERS_ORG_SUCCESS,
	FETCH_ALL_USERS_ORG_FAILURE,
	FETCH_ALL_PERMISSIONS_NOT_ORG_START,
	FFETCH_ALL_PERMISSIONS_NOT_ORG_SUCCESS,
	FETCH_BENE_ONLY_FAILURE,
	FETCH_BENE_ONLY_START,
	FETCH_BENE_ONLY_SUCCESS,
	PROMOTE_BENEFICIARY_FAILURE,
	PROMOTE_BENEFICIARY_START,
	PROMOTE_BENEFICIARY_SUCCESS,
} from './groups.selector';

export const fetchGroupsStart = createAction(
	FETCH_GROUPS_START,
	props<{ id: string }>(),
);
export const fetchGroupsSuccess = createAction(
	FETCH_GROUPS_SUCCESS,
	props<{ groups: OrgGroups[] }>(),
);
export const fetchGroupsFailure = createAction(FETCH_GROUPS_FAILURE);

export const fetchUsersStart = createAction(
	FETCH_USERS_START,
	props<{ id: string }>(),
);
export const fetchUsersSuccess = createAction(
	FETCH_USERS_SUCCESS,
	props<{ groupUsers: GroupUser[] }>(),
);
export const fetchUsersFailure = createAction(FETCH_USERS_FAILURE);

export const fetchAllOrgUsersStart = createAction(
	FETCH_ALL_USERS_ORG_START,
	props<{ groupId: string; orgId: string }>(),
);
export const fetchAllOrgUsersSuccess = createAction(
	FETCH_ALL_USERS_ORG_SUCCESS,
	props<{ users: any }>(),
);
export const fetchAllOrgUsersFailure = createAction(
	FETCH_ALL_USERS_ORG_FAILURE,
);

export const fetchAllPermissionsStart = createAction(
	FETCH_ALL_PERMISSIONS_NOT_ORG_START,
	props<{ groupId: string }>(),
);
export const fetchAllPermissionsSuccess = createAction(
	FFETCH_ALL_PERMISSIONS_NOT_ORG_SUCCESS,
	props<{ groupPermissions: Permission[]; permissions: Permission[] }>(),
);

export const updateUsersStart = createAction(
	UPDATE_USERS_START,
	props<{
		id: string;
		orgId: string;
		usersToAdd: string[];
		usersToRemove: string[];
	}>(),
);
export const updateUsersSuccess = createAction(UPDATE_USERS_SUCCESS);
export const updateUsersFailure = createAction(UPDATE_USERS_FAILURE);

export const updatePermissionsStart = createAction(
	UPDATE_PERMISSIONS_START,
	props<{
		id: string;
		orgId: string;
		permissionsToAdd: string[];
		permissionsToRemove: string[];
	}>(),
);
export const updatePermissionsSuccess = createAction(
	UPDATE_PERMISSIONS_SUCCESS,
);
export const updatePermissionsFailure = createAction(
	UPDATE_PERMISSIONS_FAILURE,
);

export const fetchBeneOnlyStart = createAction(
	FETCH_BENE_ONLY_START,
	props<{ orgId: string }>(),
);
export const fetchBeneOnlySuccess = createAction(
	FETCH_BENE_ONLY_SUCCESS,
	props<{ beneUsers: BeneficiaryGroupUser[] }>(),
);
export const fetchBeneOnlyFailure = createAction(FETCH_BENE_ONLY_FAILURE);

export const promoteBeneToAdminStart = createAction(
	PROMOTE_BENEFICIARY_START,
	props<{ beneficiaries: string[]; groupId: string }>(),
);
export const promoteBeneToAdminSuccess = createAction(
	PROMOTE_BENEFICIARY_SUCCESS,
);
export const promoteBeneToAdminFailure = createAction(
	PROMOTE_BENEFICIARY_FAILURE,
);
